export const MYPAGE_CONSTANTS = {
  STRING: {
    PICKUP_MOVIE_NOTIFICATION: '「PICK UP」「動画」アイコン表示がある場合、そちらより詳細を確認できます。',
    GUIDELINE_SUBMIT_SURVEY: '選考予定日の10:00以降、感想を登録するボタンが表示されますのでご入力をお願いいたします。',
    WISHINDSCTG_MAPPING_ERR_MESG: '経験業種が登録されていないため、経験業種をコピーできませんでした。\n'
                                + '「登録情報変更→基本情報変更」より「経験業種」をご確認ください。\n'
                                + '※基本情報変更画面ではご連絡先や希望業種・希望職種・経験業種・経験職種などの登録・変更が可能です。',
    WISHOCUPCTG_MAPPING_ERR_MESG: '経験職種が登録されていないため、経験職種をコピーできませんでした。\n'
                                + '「登録情報変更→基本情報変更」より「経験職種」をご確認ください。\n'
                                + '※基本情報変更画面ではご連絡先や希望業種・希望職種・経験業種・経験職種などの登録・変更が可能です。',
    NO_SEL_ON_BRIEFING_SESSION: '説明会へのご参加を予定されているため（もしくはご参加後であるため）、担当者に直接ご連絡をお願いいたします。',
    NO_SEL_ON_BRIEFING_SESSION_MULTI: '下記求人は、説明会へのご参加を予定されているため（もしくはご参加後であるため）、担当者に直接ご連絡をお願いいたします。',
    IGNORED_ORDER_ERR_MESG_BULK: '下記求人は、別タブなどから更新されて状態が変わっておりましたため、操作を実行できませんでした。各タブより下記求人の状態をご確認ください。',
    IGNORED_ORDER_ERR_MESG_SINGLE: '別タブなどから更新されて状態が変わっておりましたため、操作を実行できませんでした。各タブより下記求人の状態をご確認ください。',
    REAPPLY_DENY_MESG: '過去に説明会に参加されているようです。応募を希望される場合は担当のキャリアアドバイザーにご連絡をお願いいたします。',
    MAIL_SUBJECT_INTERVIEW_PREFIX: '※要面談予約※',
    NO_ACCESS_RIGHTS: 'アクセス権がありません。',
    FAVORITE_DONE: '気になるリストに追加しました。',
    UN_FAVORITE_DONE: '気になるリストから削除しました。',
    ERROR_FAVORITE: '進捗情報の更新(気になるフラグ)に失敗しました。',
    JOB_SEARCH_NOT_SPECIFIED_VALUE: '指定しない',
    JOB_SEARCH_PUBLIC_REGIST_DONE: '検索条件を保存しました。',
    JOB_SEARCH_PUBLIC_REMOVE_CFM: '検索条件を削除します。よろしいですか？',
    JOB_SEARCH_PUBLIC_REMOVE_DONE: '削除しました。',
    INTRODUCED_CONTACT_DESCRIPTION: 'ご応募済みの企業です。ご不明な点がございましたら担当者にご連絡をお願いいたします。',
    NO_AVAILABLE_JOB_MSG: '対象の求人がありません。',
    FAIL_REGISTER_PROGRESS_HISTORY_MSG: '進捗履歴情報の登録に失敗しました。',
    FAIL_UPDATE_PROGRESS_MSG: '進捗情報の更新に失敗しました。',
    NO_SEARCH_RESULTS_MSG: '検索結果が0件です',
    RECAPTCHA_EMPTY_TOKEN: '「私はロボットではありません」にチェックを入れてください。',
    COLON_SPACE: ' ： ',
    FAVORITE_ERROR_MSG_BULK: '下記は状態が更新されており操作できませんでした。各タブで求人の状態をご確認ください。'
  },
  JOB_SEARCH_PUBLIC_AREAS: [
    {id: '01', text: '関東'},
    {id: '02', text: '関西'},
    {id: '03', text: '東海'},
    {id: '04', text: '北海道・東北'},
    {id: '05', text: '甲信越'},
    {id: '06', text: '北陸'},
    {id: '07', text: '中国・四国'},
    {id: '08', text: '九州・沖縄'},
    {id: '09', text: '海外'},
  ],
  FAVORITE_HTTP_CODE: {
    METHOD_NOT_ALLOWED: 'パラメータがありません',
    SESSION_TIMEOUT: 'セッションがタイムアウトしました。',
    ERROR_OCCURRED: 'エラーが発生しました。',
    COMMUNICATION_FAILED: '通信に失敗しました。',
  },
  // Cookie timeout in minutes
  COOKIE_TIMEOUT: <Record<string, {NAME: string, TIMEOUT: number}>>{
    ADVERTISEMENT_DIALOG: {
      NAME: 'ads_dialog',
      TIMEOUT: 120,
    },
    ADVERTISEMENT_LOGIN_COUNT: {
      NAME: 'ads_logincount',
      TIMEOUT: 120,
    },
    LOGIN_MAIL: {
      NAME: 'login_mail',
      TIMEOUT: 4320,  // 3 days
    }
  },
  SESSION_KEY: {
    PENDING_FILTERS: 'pending_filters',
    JOBSEARCH_FILTERS: 'jobsearch_filters',
    JOBSEARCH_SORT: 'jobsearch_sort',
    JOBSEARCH_PUBLIC_SEARCHCOND: 'jobsearch_public_searchcond',
    JOBSEARCH_PUBLIC_SEARCHCARD: 'jobsearch_public_searchcard',
    JOBSEARCH_PUBLIC_SEARCH_COMPANY: 'jobsearch_public_search_company',
    APPLY_SORT: 'apply_sort',
    RECAPTCHA_VERSION: 'recaptcha_version',
    IS_FIRST_LOGIN: 'is_first_login',
    MAIL_SECURITY_HOME_POPUP_DISMISSED: 'mail_security_home_popup_dismissed',
  },
  CAREER_SETTING_FLAGS: {
    N003_CAREER: '求職者情報が存在しません。',
    N003_MYPAGE: 'マイページ情報の取得に失敗しました。',
    E002_CAREER: '求職者情報の更新に失敗しました。',
    E002_MYPAGE: 'マイページ情報の更新に失敗しました。',
  },
  COMMON_ERROR_MESSAGES: {
    NETWORK_FAILURE: '通信に失敗しました。',
    SESSION_TIMEOUT: 'セッションがタイムアウトしました。',
  },
  ORDER_APPROVED_STATUS:{
    STATUS_APPROVED: 5,
  },
  TRNSHINTYOKU_STATUS:{
    STATUS_INTRODUE: [11, 21],
    STATUS_REFUSAL: [8, 9],
    STATUS_AFTER_APPLY: [19, 12, 1, 2, 3, 4, 26, 27, 30, 6, 31, 14, 22, 10, 25, 9, 17, 24, 8, 7],
  },
  ORDER_BULK_LIMIT: {
    SELECT_CHECK: '一括操作で選択できる件数は20件までです'
  },
  ADVISOR: {
    RESUME_TYPE : 'resume',
    HISTORY_TYPE : 'history',
    SUBMIT_RESUME_SUCCESS: '履歴書の提出を<br>受け付けました',
    SUBMIT_HISTORY_SUCCESS: '職務経歴書の提出を<br>受け付けました',
    MEMO_OVER_100: 'メモは100文字以下で入力してください。',
    MEMO_SPACE: 'メモ半角スペース不可。',
    MEMO_KANA: 'メモ半角カナ不可。',
    MEMO_PROHIBITED: 'メモ禁則エラー。',
    PAGE_NOT_FOUND: 'ページが存在しません。'
  },
  STORE_MST:{
    MST_ANUAL_SLRY: 'mstMyPage/fetchMstAnualSlry',
    MST_OVERTIME: 'mstMyPage/fetchMstOvertime',
    MST_REMOTE_WORK_ORDER: 'mstMyPage/fetchMstRemoteWorkOrder',
    MST_SIDE_BUSINESS_ORDER: 'mstMyPage/fetchMstSideBusinessOrder',
    MST_FEATURES: 'mstMyPage/fetchMstFeatures',
    MST_FEATURES_ORDER: 'mstMyPage/fetchMstFeaturesOrder',   
    MST_PREF: 'mstMyPage/fetchMstPref',
    MST_CITY: 'mstMyPage/fetchMstCity',    
    MST_WALK_BUS: 'mstMyPage/fetchMstWalkBus',
    MST_STATION: 'mstMyPage/fetchMstStation',
    MST_ENTRANCE: 'mstMyPage/fetchMstEntrance',
    MST_GRADUATION: 'mstMyPage/fetchMstGraduation',
    MST_INHABIT_TYPE: 'mstMyPage/fetchMstInhabitType',
    MST_ALLOWANCE: 'mstMyPage/fetchMstAllowance',
    MST_PEOPLE_MANAGEMENT: 'mstMyPage/fetchMstPeopleManagement',
    MST_PEOPLE_MANAGEMENT_YEAR: 'mstMyPage/fetchMstPeopleManagementYear',
    MST_LISTED: 'mstMyPage/fetchMstListed',
    MST_INDUSTRY: 'mstMyPage/fetchMstIndustry',
    MST_OCUP3: 'mstMyPage/fetchMstOccupation3',
    MST_CHANGE_ADDR: 'mstMyPage/fetchMstChangeaddr',
    MST_EMPLOYEE: 'mstMyPage/fetchMstEmployee',
    MST_JOB_CHANGE_TIME: 'mstMyPage/fetchMstJobchangetime',
    MST_SELECTION_PHASE: 'mstMyPage/fetchMstSelectionPhase',
    MST_ASPIRATION: 'mstMyPage/fetchMstAspiration',
    MST_COURSE: 'mstMyPage/fetchMstCourse',    
    DIALOG_OCCUPATION: 'mstMyPage/fetchDialogOccupation',    
    DIALOG_PREF: 'mstMyPage/fetchDialogPref',
    DIALOG_INDUSTRY: 'mstMyPage/fetchDialogIndustry',
    MST_LANGUAGE_LEVEL: 'mstMyPage/fetchMstLanguageLevel',    
    MST_OTRLANG: 'mstMyPage/fetchMstOtrLang',
    MST_LICENSES: 'mstMyPage/fetchMstLicenses',
    MST_SEX: 'mstMyPage/fetchMstSex',
    MST_WK_STATUS: 'mstMyPage/fetchMstWkStatus',
    MST_LSTSCHL: 'mstMyPage/fetchMstLstschl',
    MST_SCHOOL: 'mstMyPage/fetchMstSchool',
    MST_EMPTYPE: 'mstMyPage/fetchMstEmpType',
    MST_YEAR_CATEGORY: 'mstMyPage/fetchMstYearCategory',
    MST_APPLY: 'mstMyPage/fetchMstApply',
    MST_FAILURE: 'mstMyPage/fetchMstFailure',
    MST_PURPOSEAGENT: 'mstMyPage/fetchMstPurpoSeagent',
  },
  RECOMMEND : {
    MAX_WISH_AREA : 3,
    MAX_WISH_INDUSTRY : 6,
    MAX_WISH_OCCUP : 6,
    MAX_JOBCHANGE : 20
  },
  SCREN_NAME_MULTI_APPLY : {
    PENDING : "pending",
    JOBSEARCH: "jobsearch"
  },
  // 全国
  MSTPREF_NATIONAL_ID: 49,
  // 海外
  MSTPREF_FOREIGN_ID: 48,
  // 海外
  MSTAREA_FOREIGN_ID_OLD: '9999999',
  MSTAREA_FOREIGN_ID: '09',

  ENTRY_FORM_TYPE_PARAMS_KEY: 'ty',
  ENTRY_FORM_TYPE_PARAMS_VALUE: 'bscv',
};
